import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-3" }
const _hoisted_2 = {
  key: 1,
  class: "text-success fw-bold d-flex align-items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg fs-1 text-success" }, null, -1)
const _hoisted_4 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ProyectoN2DatosGenerales = _resolveComponent("ProyectoN2DatosGenerales")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_ProyectoN2BolsaCuidados = _resolveComponent("ProyectoN2BolsaCuidados")!
  const _component_ProyectoN2Empleo = _resolveComponent("ProyectoN2Empleo")!
  const _component_ProyectoN2Formacion = _resolveComponent("ProyectoN2Formacion")!
  const _component_ProyectoN2ServiciosColectivos = _resolveComponent("ProyectoN2ServiciosColectivos")!
  const _component_ProyectoN2ServiciosIndividuales = _resolveComponent("ProyectoN2ServiciosIndividuales")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.sincronizado)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _ctx.sincronizarHub
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectosN2.acciones.button")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("formularios.proyectosN2.yaSincronizado.button")), 1)
            ]))
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        type: "border-card",
        modelValue: "datosProyecto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            name: "datosProyecto",
            label: _ctx.$t('formularios.proyectosN2.tabs.general')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ProyectoN2DatosGenerales)
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.token)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('formularios.proyectosN2.tabs.bolsaCuidados'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProyectoN2BolsaCuidados)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.token)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('formularios.proyectosN2.tabs.empleo'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProyectoN2Empleo)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.token && !_ctx.recoleccionDatosExternos)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 2,
                label: _ctx.$t('formularios.proyectosN2.tabs.formacion'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProyectoN2Formacion)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.token && !_ctx.recoleccionDatosExternos)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 3,
                label: _ctx.$t('formularios.proyectosN2.tabs.serviciosColectivos'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProyectoN2ServiciosColectivos)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.token && !_ctx.recoleccionDatosExternos)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 4,
                label: _ctx.$t('formularios.proyectosN2.tabs.serviciosIndividuales'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ProyectoN2ServiciosIndividuales)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}